import { Injectable, Output, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UserRole } from "../models/user-role.model";
import { UserRoleService } from "./user-role.service";
import { lastValueFrom } from "rxjs";
import { AccountService, User } from "@done/ngx-essentials";
import { UserService } from "./user.service";
import { EmployeeService } from "../../../shared/services/employee.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from "../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class PermissionService {

    private _role: UserRole | null = null;
    private user: User | null = null;

    public get role(): UserRole | null {
        return this._role;
    }

    @Output() roleUpdated: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private readonly _http: HttpClient,
        private readonly _accountService: AccountService,
        private readonly _userService: UserService,
        private readonly _snackbar: MatSnackBar,
    ) { }

    async canAccessRoute(role?: string): Promise<boolean> {
        // AT-1224: token de acesso expirado localmente não significa sessão morta — só
        // bloqueia quando não existe sessão alguma (getUserId), não pela validade
        // estrita do access token (isLoggedIn).
        if (!this._accountService.getUserId())
            return false;

        if (!role)
            return true;

        await this.init();

        return this._role?.profile === role;
    }

    async init(): Promise<void> {
        this._role = new UserRole();
        const userId = this._accountService.getUserId();

        if (!userId)
            return;
        let account = this._accountService.getSessionData()?.account;

        this._userService.findAlcadaApontamentos(userId, account?.id).subscribe((alcada: string) => {
            if (alcada == null || alcada == undefined || alcada == "") {
                this._snackbar.open(`Alçada não encontrada, entre em contato com o administrador do sistema.`, 'Fechar')

                setTimeout(() => {
                    window.location.href = `${environment.doneWorkspaceApp}/login?logout=true&returnUrl=${environment.donePointerApp}/login`;
                }, 2000);
            }

            this._role.profile = alcada

            this.roleUpdated.emit();
        });
    }

    dispose(): void {
        this._role = null;
        this.roleUpdated.emit();
    }
}